import moment from 'moment';
// eslint-disable-next-line import/prefer-default-export
export const getAcademicYear = day => {
    const shortYear = Number(moment(day).format(`YY`));
    const monthDay = moment(day).format(`MMDD`);
    const academicYear =
        monthDay >= '0801'
            ? `${shortYear}/${shortYear + 1}`
            : `${shortYear - 1}/${shortYear}`;
    return academicYear;
};
